// Generated by ts-to-zod
import { z } from 'zod';
import { sectionDataSchema } from '../../../annotations/models/annotationData.schema';
import {
  queueActionSchema,
  queueRuleSchema,
} from '../../../rules/models/queueRule.schema';
import { messageSchema } from '../../../shared/models/message.schema';
import { urlSchema } from '../../../utils/codecUtils.schema';

export const evaluateRulesPayloadSchema = z.object({
  queue: urlSchema,
  annotationContent: z.array(sectionDataSchema).optional(),
  schemaRules: z.array(queueRuleSchema.partial()),
  annotation: urlSchema.optional(),
});

export const evaluateRulesResponseSchema = z.object({
  conditionValues: z.array(z.array(z.boolean())),
  messages: z.array(messageSchema),
  actions: z.array(queueActionSchema),
});
